import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M16.375 2c.166 0 .325.066.442.183l5 5a.625.625 0 0 1 .183.442v8.75a.625.625 0 0 1-.183.442l-5 5a.625.625 0 0 1-.442.183h-8.75a.625.625 0 0 1-.442-.183l-5-5A.625.625 0 0 1 2 16.375v-8.75c0-.166.066-.325.183-.442l5-5A.625.625 0 0 1 7.625 2zm-.455 1.667H8.08L3.667 8.08v7.84l4.413 4.413h7.84l4.413-4.413V8.08L15.92 3.667zm-3.954 12.6l.088.004a.8.8 0 1 1-.088-.004zm0-10c.442 0 .8.298.8.666V13.6c0 .368-.358.667-.8.667-.441 0-.8-.299-.8-.667V6.933c0-.368.359-.666.8-.666z' />
  </svg>
);
